import React from "react";
import MainPage from "./Components/mainPage";
import FeaturesCarousel from "./Components/featuresCarousel";
import Benefits from "./Components/benefits";
import AppShowcase from "./Components/appShowcase";

const Home = () => {
    return (
        <>
            {/* white */}
            <MainPage />
            {/* orange */}
            <FeaturesCarousel />
            {/* white */}
            <Benefits />
            {/* orange */}
            <AppShowcase />
        </>
    );
};

export default Home;
